import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: "im-item-sections-dialog",
    templateUrl: "./item-sections-dialog.component.html",
    styleUrl: "./item-sections-dialog.component.scss",
    standalone: false
})
export class ItemSectionsDialogComponent implements OnInit {
  public sectionForm;

  constructor(
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) private dialogData: any,
  ) {}

  public ngOnInit(): void {
    this.sectionForm = JSON.parse(JSON.stringify(this.dialogData?.sectionForm));
    this.sectionForm.sections.forEach((section) => (section.selected = true));
  }

  public back(): void {
    this.dialogRef.close({
      option: "back",
    });
  }

  public cancel(): void {
    this.dialogRef.close({
      option: "cancel",
    });
  }

  public create(): void {
    this.createSectionItemToSend();
    this.dialogRef.close({
      data: this.dialogData.sectionForm,
      option: "create",
    });
  }

  public sectionSelectionChange(sectionId: string): void {
    var section = this.sectionForm.sections.find(
      (section) => section.id == sectionId,
    );
    section.selected = !section.selected;
    this.sectionForm.sections.forEach((chillSection) => {
      if (chillSection.grouping.parentId == sectionId) {
        if (!section.selected) chillSection.selected = false;
      }
    });
  }

  private createSectionItemToSend(): void {
    this.sectionForm.sections.forEach((section) => {
      if (!section.selected) {
        let index = this.dialogData.sectionForm.sections.findIndex(
          (s) => s.id == section.id,
        );
        this.dialogData.sectionForm.sections.splice(index, 1);
      }
    });
  }
}
